import React, { useEffect, useState } from 'react';
import styled from '@emotion/native';
import { TouchableOpacity, Image, Linking } from 'react-native';
import { BodyText } from '@/shared/components/StyledText';
import { green, accent, sand } from '@/shared/styles/colors';
import { BOX_SHADOW_STYLE } from '@/shared/styles/constants';
import {
  StorageKeys,
  StorageService,
} from '@/services/storage/Storage.service';
import { EMME_EVENT_LANDING } from '@/shared/constants/utility';

const EventBanner = () => {
  // Check if banner was previously dismissed
  const [isBannerDismissed, setIsBannerDismissed] = useState(false);
  const [hasRendered, setHasRendered] = useState(false);

  useEffect(() => {
    const checkBannerDismissed = async () => {
      try {
        const dismissed = await StorageService.getItem(
          StorageKeys.EVENT_BANNER_DISMISSED,
        );
        setIsBannerDismissed(dismissed === 'true');
        setHasRendered(true);
      } catch (error) {
        // If there's an error, default to showing the banner
        setIsBannerDismissed(false);
        setHasRendered(true);
      }
    };
    checkBannerDismissed();
  }, []);

  const onLearnMorePress = () => {
    Linking.openURL(EMME_EVENT_LANDING);
  };

  const onDismiss = async () => {
    setIsBannerDismissed(true);
    try {
      await StorageService.setItem(StorageKeys.EVENT_BANNER_DISMISSED, 'true');
    } catch (error) {
      // Silent fail - not critical if storage fails
      console.warn('Failed to save banner dismissal state:', error);
    }
  };

  if (!hasRendered) {
    return null;
  }

  return (
    <BannerWrapper>
      <BannerContainer style={{ display: isBannerDismissed ? 'none' : 'flex' }}>
        <ContentContainer>
          <EventSubtitle>
            Filter to view NYC stylists available in person.{' '}
            <LearnMoreText onPress={onLearnMorePress}>Learn more</LearnMoreText>
          </EventSubtitle>

          <DismissButton onPress={onDismiss}>
            <DismissIcon source={require('@/assets/images/CloseIcon.png')} />
          </DismissButton>
        </ContentContainer>
      </BannerContainer>
    </BannerWrapper>
  );
};

export default EventBanner;

const BannerWrapper = styled.View({
  paddingBottom: 16,
  backgroundColor: sand,
});

const BannerContainer = styled.View({
  backgroundColor: accent,
  width: '100%',
  ...BOX_SHADOW_STYLE,
  elevation: 3,
  overflow: 'hidden',
});

const ContentContainer = styled.View({
  flexDirection: 'row',
  alignItems: 'center',
  paddingRight: 12,
  paddingVertical: 6,
  paddingLeft: 36,
  justifyContent: 'space-between',
});

const EventSubtitle = styled(BodyText)({
  color: green,
  fontSize: 12,
});

const LearnMoreText = styled(BodyText)({
  color: green,
  fontSize: 13,
  textDecorationLine: 'underline',
  fontWeight: '600',
});

const DismissButton = styled(TouchableOpacity)({
  width: 12,
  height: 12,
  justifyContent: 'center',
  alignItems: 'center',
});

const DismissIcon = styled(Image)({
  width: 16,
  height: 16,
  resizeMode: 'contain',
  tintColor: green,
});
